<template>
  <div>    
	<el-tabs type="border-card"> 
		<el-tab-pane label="核销中心">	
			<el-form    ref="form"   :model="so" label-width="80px" style="background: #FFFFFF; padding: 20px 20px 20px 80px;" >
			 <div style="display: flex;" >
				<el-form-item label="卡密" style="width: 30%;">
					<el-input v-model="so.hexiaokami" placeholder="核销卡密"></el-input>
				</el-form-item>
			    <el-button type="primary" size="small" style='height:40px;margin-left:10px'  @click="Chaxun">查询</el-button>
				<el-form-item label="核销金额" style="width: 30%;">
					<el-input  :disabled="jingzhi==1?true:false" v-model="so.hexiaojine" placeholder="核销金额"></el-input>
				</el-form-item>
			    <el-button type="primary" size="small" style='height:40px;margin-left:10px'  @click="Hexiao">核销</el-button>
			   </div>
			   <div style="display: flex;">
				   <div v-if="jine>-1"  style="width: 30%;text-align: left;padding-left: 35px; ">剩余金额：￥{{jine}}</div>
				   <div v-if="jine>-1"  style="text-align: left;padding-left: 35px; ">剩余次数：{{shengyucishu}}次</div>
			   </div>
			<!-- <div><a href="https://store_cash.fxqifu.com/welcome/login/1004119" target="_Blank"><el-button type="primary"   style='margin-left:50px'>左福右利臻享型</el-button></a></div>
			 <div style='margin-top:20px'>
				<a href="https://store_cash.fxqifu.com/welcome/login/1002125" target="_Blank"><el-button type="success"  style='margin-left:50px'>左福右利标准型	</el-button></a>
			 </div> -->
			   </el-form>
		</el-tab-pane>
		<el-tab-pane label="订单核销">
			<el-form    ref="form"   :model="hexiaoshu" label-width="80px" style="background: #FFFFFF; padding: 20px 20px 20px 80px;" >
				<el-form-item label="提货码" style="width:90%;">
					<div style="display: flex;">
						<el-input v-model="hexiaoshu.hexiaoma" placeholder="提货码"></el-input>
						<el-button type="primary" size="small" style='height:40px;margin-left:10px'  @click="Chaxun2">查询订单</el-button>
					</div>
				</el-form-item>
			</el-form>
			<!-- e2gzswu6 -->
			<div style="min-width: 800px;">
				<div style="padding: 10px;background-color:#f4f4f5;display: flex;border-radius: 4px;">
					<div style="font-size: 12px;color:#909399 ;">订单号：{{hexiaodingdan.dingdanhao}}</div>
					<div style="font-size: 12px;color:#909399 ;margin-left: 20px;">下单时间：{{hexiaodingdan.xiadanshijian}}</div>
				</div>
				<div>
					<el-table :data="hexiaodingdan.shangpin" style="width: 100%" stripe>
						<el-table-column prop="id" label="ID" width="80"></el-table-column>
						<el-table-column label="商品" width="400" style="position: relative;display: flex;">
							<template slot-scope="shu">
								<div style="display: flex;">
									<div style="width: 70px; height:70px; margin-right:16px;">
										<el-image style="width: 70px; height:70px;" :src="shu.row.tu" ></el-image>
									</div>
									<div class="">
										<div style="color: #333;font-size: 14px;">{{shu.row.ming}}</div>
										<div style="color: #ccc;font-size: 14px;">
											<span>价格：</span>
											<span style="color:red;">￥{{shu.row.jiage}}</span>
											<span style="margin-left: 20px;">数量：</span>
											<span >￥{{shu.row.shuliang}}</span>
										</div>
									</div>
								</div>
							</template>
						</el-table-column>
						<el-table-column label="买家" width="200" >
							<template slot-scope="shu">
								<div style="color: #409EFF;font-size: 12px;">{{shu.row.nicheng}}</div>
								<div style="color: #333;font-size: 12px;">收货人：{{shu.row.shouhuoren}}</div>
								<div style="color: #333;font-size: 12px;">[{{shu.row.shouhuodianhua}}]</div>
							</template>
						</el-table-column>
						<el-table-column label="支付方式" width="200" >
							<template slot-scope="shu">
								<!-- zhifuqudao -->
								<el-tag type="success" effect="dark" >{{shu.row.zhifuqudao_wenzi}}</el-tag>
							</template>
						</el-table-column>
						<el-table-column label="价格" width="200" >
							<template slot-scope="shu">
								<div>总价：{{shu.row.zongjia}}</div>
								<div>运费：{{shu.row.yunfei}}</div>
							</template>
						</el-table-column>
						<el-table-column label="状态" >
							<template slot-scope="shu">
								<el-tag type="danger" effect="dark" v-if="shu.row.zhuangtai==10 && shu.row.peisong==1">待提货</el-tag>
								<el-tag type="danger" effect="dark" v-else-if="shu.row.zhuangtai==10 && shu.row.peisong==3">待发货</el-tag>
								<el-tag type="danger" effect="dark" v-else-if="shu.row.zhuangtai==30 && shu.row.peisong==1">已提货</el-tag>
								<el-tag type="danger" effect="dark" v-else-if="shu.row.zhuangtai==30 && shu.row.peisong==3">已收货</el-tag>
							</template>
						</el-table-column>
						<el-table-column label="操作" >
							<template slot-scope="shu">
								<el-button v-if="shu.row.zhuangtai==10" type="primary" size="small" style='height:40px;margin-left:10px'  @click="Hxiaodindan(shu.row)">核销订单</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
			
		</el-tab-pane>
	</el-tabs>
	
  </div>
</template>

<script>
var that;
export default {
  data() {
    return {
     
      shu: {
        lie: [],
        zongshu: 0,
		leixing:[],
		weiyongshu: 0,
		jifenshu:0,
		hexiaoyuannicheng:'',
		hexiaoyuan:''
      },
      so: {zhuangtai:'',ye: 1,jitiao: 20},
      options: [{ label: "不限", value: "" },{ label: "待到账", value: "0" },{ label: "已到账", value: "1" }],
	  jine:-1,
	  jingzhi:1,
	  shengyucishu:0,
	  urls:'',
	  charushu:{},
	  pingtais:1,
	  hexiaoshu:{},
	  hexiaodingdan:{},
	  dd:''
	}
  },
  created() {
    that = this;
    this.CSH();
	this.so.zongshid=this.$qu('shids')
  },
  watch:{
	'so.hexiaokami':function(){
		if(!this.so.hexiaokami){
			this.jine=-1
		}
	}  
  },
  
  
  methods: {
	  CSH() {
	  	this.$post('k=index')
		// this.$post("k=index",{ye: 1,jitiao: 20}, function(s) {
		      // this.shu = s.shu;
			  // this.shu.zongshu =parseInt(s.shu.zongshu);
		    // });
	  },
	  Hexiaopingtai(){
	  	 this.$post("k=hexiaomingxi&c=hexiaopintai", this.so, (s)=> {
	  		 this.$xiaoxi(s.shu)
	  	 })
	  },  
	  Hexiao(){
		  var that=this
		  console.log(that.so)
		  if(that.so.hexiaokami.indexOf('G')===0){
		  	console.log(111)
		  	that.urls='https://ghyx.fubetter.com/shanghu.php?d=33'
			that.pingtais=2
		  }
		  // else if(that.so.hexiaokami.indexOf('S')===0){
			 //  that.pingtais=3
				// that.urls='https://sfcloud.fubetter.com/shanghu.php?d=33'
		  // 	console.log(222)
		  // }
		  else if(that.so.hexiaokami.indexOf('F')===0){
		  	console.log(111)
		  	that.urls='https://ghyf.fubetter.com/shanghu.php?d=33'
			that.pingtais=4
		  }else{
			  that.pingtais=1
			  that.urls=''
		  }
		  
		  that.$post("k=hexiaomingxi&c=hexiao", that.so, (s)=> {
			 if(s.shi==1){
				that.$xiaoxi('扣除成功')
				that.charushu=s.shu
				that.charujilu()
			 }else{
				 that.$xiaoxi(s.shu)
			 }
		  },that.urls)
	},  
	charujilu(){
		var that=this
		that.charushu.pingtais= that.pingtais
		that.$post("k=hexiaomingxi&c=Hexiaopintai",that.charushu, (s)=> {
		})
	},
	Chaxun2(){
		// e2gzswu6
		var that=this
		that.$post("k=hexiaomingxi&c=dingdanchaxu",that.hexiaoshu, (s)=> {
			if(s.shi==1){
				that.hexiaodingdan=s.shu
				console.log(that.hexiaodingdan)
			}else{
				that.$xiaoxi(s.shu)
			}
		})
	},
	Hxiaodindan(e){
		var that=this
		that.$post("k=hexiaomingxi&c=Dingdanhexiao",{id:e.dingdanhao}, (s)=> {
			that.$xiaoxi(s.shu)
			that.Chaxun2();
		})
	},
	Chaxun(){
		if(this.so.hexiaokami.indexOf('G')===0){
			this.urls='https://ghyx.fubetter.com/shanghu.php?d=33'
		}
		// else if(this.so.hexiaokami.indexOf('S')===0){
		// 	this.urls='https://sfcloud.fubetter.com/shanghu.php?d=33'
		// }
		else if(this.so.hexiaokami.indexOf('F')===0){
			this.urls='https://ghyf.fubetter.com/shanghu.php?d=33'
		}else{
			this.urls=''
		}
		this.$post("k=hexiaomingxi&c=Chaxunhexiao", this.so, (s)=> {
			if(s.shi==1){
				if(s.shu.leixing){
					this.jine=s.shu.jine
					this.jingzhi=1
					this.so.hexiaojine = Number(s.shu.cun.jine) /(Number(s.shu.cun.cishu)-Number(s.shu.cun.shiyongcishu))
					this.shengyucishu=Number(s.shu.cun.cishu)-Number(s.shu.cun.shiyongcishu)
				}else{
					this.jine=s.shu
					this.jingzhi=0
				}
			}else{
				 this.$xiaoxi(s.shu)
			}	 
		},this.urls)
	},
	  
	  
  //   CSH() {     
  //     that.$post("k=huiyuan&c=Fulika", that.so, function(s) {
  //       that.shu = s.shu;
		// that.shu.zongshu =parseInt(s.shu.zongshu);
  //     });
  //   },
	
	Daochu(){
		this.$post('k=huiyuan&c=Daochufulika', that.so, function(s) {
			if(s.shi==1){
				window.open(that.$url+'&k=denglu&c=daochu&wenjianming='+s.shu);  
			}else{
				that.$xiaoxi(s.shu);			
			}
		});
	},
  }
};
</script>

<style>
.biaoti {
  display: block;
  width: 100%;
  text-indent: 10px;
  margin-bottom: 16px;
  font-size: 20px;
  color: #788188;
}
.ddlie{
	width: ;
}
 /*包含以下四种的链接*/
 a {
	 color:#fff;
     text-decoration: none;
 }
 /*正常的未被访问过的链接*/
 a:link {
     text-decoration: none;
 }
 /*已经访问过的链接*/
 a:visited {
     text-decoration: none;
 }
 /*鼠标划过(停留)的链接*/
 a:hover {
     text-decoration: none;
 }
 /* 正在点击的链接*/
 a:active {
     text-decoration: none;
 }

</style>
